var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.$store.getters.showPromo)?_c('div',{staticClass:"promo-pointer",on:{"click":_vm.goToPromo}},[_c('div',{staticClass:"close-promo",on:{"click":function($event){$event.stopPropagation();return _vm.close.apply(null, arguments)}}},[_vm._m(0)])]):_vm._e()
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"icon-close-container"},[_c('span',{staticClass:"icon-close"})])
}]

export { render, staticRenderFns }